<!--~
~ Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<form name='resetPasswordForm'
  (ngSubmit)='submitForm()'
  [formGroup]='passwordForm'>
  <input type='hidden' id='username' name='username' autocomplete='username' />
  <div fxLayout='column' fxLayoutAlign='start start'>
    <mat-form-field>
      <input matInput type="password"
        id='new-password'
        name='new-password'
        [placeholder]="'New Password:'"
        autocomplete='new-password'
        formControlName="newPassword"/>
      <mat-error>{{ getError('newPassword') }}</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input matInput type="password"
        id='new-password-confirm'
        name='new-password-confirm'
        [placeholder]="'Confirm New Password:'"
        [errorStateMatcher]="matcher"
        autocomplete='new-password'
        formControlName="newPasswordConfirm"/>
      <mat-error>{{ getError('newPasswordConfirm') }}</mat-error>
    </mat-form-field>
    @if (complexity) {
      <dash-gis-password-complexity [complexity]='complexity'></dash-gis-password-complexity>
    }
  </div>

  <div class='reset-password-buttons' fxLayout="row" fxLayoutAlign="end center">
    @if (allowClose) {
      <button mat-button
        type="button"
      (click)='cancelForm()'>Cancel</button>
    }
    <button mat-button
      color='primary'
      type="submit"
    [disabled]="passwordForm.invalid">{{ submitText }}</button>
  </div>

</form>
